import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles"
import React, {useContext, useState} from "react";
import Grid from "@mui/material/Grid";
import {PropertyDefinitionDto} from "../../../../common/apis/property/PropertyApi";
import {SaveButton} from "../../../../components/button/SaveButton";
import {CancelButton} from "../../../../components/button/CancelButton";
import SingleSelectField from "../../../../components/fields/select/SingleSelectField";
import {_transl} from "../../../../store/localization/TranslMessasge";
import Dialog from "../../../../components/dialogs/Dialog";
import DialogTitle from "../../../../components/dialogs/DialogTitle";
import DialogContent from "../../../../components/dialogs/DialogContent";
import DialogActions from "../../../../components/dialogs/DialogActions";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {ElementTranslationKey} from "./ElementTranslationKey";
import ElementPropertyDefinitionContext from "../../../../common/ElementPropertyDefinitionContext";
import {GridColDef} from "@mui/x-data-grid";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogContainer: {
            display: "flex",
            width: "100%",
            paddingTop: "1em",
            paddingBottom: "1em",
        },
        gridItem: {
            width: "100%",
            padding: theme.spacing(2, 0, 1, 0),
        },
    }));

interface CustomPropertyColumnAddDialogProps {
    open: boolean;
    existingCustomPropertyNames: string[];
    onAddCustomColumn: (attributeName: string, colDef: GridColDef) => void;
    colDef: GridColDef;
    onClosed: () => void;
}

export default function CustomPropertyColumnAddDialog(props: CustomPropertyColumnAddDialogProps) {

    const classes = useStyles();
    const {open, onAddCustomColumn, colDef, onClosed} = props;
    const existingCustomAttributeNames = new Set(props.existingCustomPropertyNames);

    const [propDef, setPropDef] = useState<PropertyDefinitionDto | null>(null);
    const [propDefError, setPropDefError] = useState<string | undefined>();
    const propertyDefinitions = useContext(ElementPropertyDefinitionContext).propertyDefinitions;

    function save() {
        if (validate()) {
            onAddCustomColumn(propDef!.name, colDef);
            close();
        }
    }

    function validate() {
        if (!propDef) {
            setPropDefError(_transl(CommonTranslationKey.FILL_OUT_THIS_FIELD));
            return false;
        }
        if (existingCustomAttributeNames.has(propDef.name)) {
            setPropDefError(_transl(ElementTranslationKey.CUSTOM_PROPERTY_COLUMN_ADD_DIALOG_COLUMN_ALREADY_EXISTS));
            return false;
        }
        return true;
    }

    function close() {
        onClosed();
        resetState();
    }

    function resetState() {
        setPropDef(null);
        setPropDefError(undefined);
    }

    function updatePropDef(newValue: PropertyDefinitionDto | null) {
        setPropDefError(undefined);
        setPropDef(newValue);
    }

    return (
        <React.Fragment>
            {propertyDefinitions &&
                <Dialog open={open}>
                    <DialogTitle title={_transl(ElementTranslationKey.CUSTOM_PROPERTY_COLUMN_ADD_DIALOG_TITLE)}
                                 onDialogClosed={close}/>
                    <DialogContent>
                        <Grid container className={classes.dialogContainer}>
                            <Grid item width={"100%"}>
                                <SingleSelectField
                                        id="name-field"
                                        label={_transl(ElementTranslationKey.CUSTOM_PROPERTY_COLUMN_ADD_DIALOG_NAME)}
                                        value={propDef}
                                        onChange={(newValue) => updatePropDef(newValue)}
                                        options={propertyDefinitions}
                                        getOptionLabel={option => (option as PropertyDefinitionDto).name}
                                        required={true}
                                        errorMessage={propDefError}/>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <SaveButton onClick={(e) => save()}/>
                        <CancelButton onClick={() => close()}/>
                    </DialogActions>
                </Dialog>}
        </React.Fragment>
    );
}
